import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SessionService } from '@app/core/state/session';
import { EMPTY, Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable()
export class CommonErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private sessionService: SessionService, private snackBar: MatSnackBar) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request)
      .pipe(
        catchError((err: any) => {
          if (err instanceof HttpErrorResponse) {
            if (!request.url.includes('/auth/login') && err && err.status === 401) {
              // unauth
              this.sessionService.clearSessionStore();
              this.router.navigate(['/login']);
              return EMPTY;
            }
            if (err && err.status === 403) {
              this.snackBar.open('Für diese Aktion(en) besitzen Sie keine Berechtigung.');
            }
            return throwError(err);
          } else {
            return throwError(err);
          }
        })
      );
  }
}
